/**
 * Formats a trip's cities for display. A trip can cover more than one city, and
 * showing only the first ("Lisbon" for a Lisbon-and-Porto trip) misrepresents
 * what the traveler actually asked for — so every surface uses this.
 */
export function formatPlaces(places: (string | null | undefined)[] | null | undefined): string {
  const list = (places ?? []).filter((p): p is string => !!p && p.trim() !== '');
  if (list.length === 0) return '';
  if (list.length === 1) return list[0];
  return `${list.slice(0, -1).join(', ')} & ${list[list.length - 1]}`;
}
